import Vue from "vue";
import App from "./App.vue";
import "./style.scss";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import auth from "./middlewares/auth";

/** Axios */
import Axios from "axios";
Axios.defaults.baseURL = "/api";
Axios.defaults.headers.common["Accepts"] = "application/json";
Axios.defaults.headers.common["Content-Type"] = "application/json";
Axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
Axios.interceptors.request.use(function(config) {
  config.headers["Device-Id"] = localStorage.getItem("device_id") || "";
  config.headers["Device-Code"] = localStorage.getItem("device_code") || "";

  return config;
});
Axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data.code === "DEVICE_NOT_AUTHORIZED"
    ) {
      router.replace({ name: "deviceNotAuthorized" });
    }

    return Promise.reject(error);
  }
);
Vue.prototype.$http = Axios;
/** /Axios */

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  store.commit("setLoading", { loading: true });
  if (to.name !== "login" && to.name !== "senha" && to.name !== "recuperar")
    store.dispatch("checkToken").then(r => {
      store.commit("setLoading", { loading: false });
      if (store.getters.isLoggedin) next();
      else next({ name: "login", query: { from: to.path } });
    });
  else next();
});

// V-mask
import "@/plugins/v-mask";

//Vuetify Money
import "@/plugins/vuetify-money";

// Moment
import "@/plugins/moment";

// Vee-Validate
import "@/plugins/vee-validate";

// Lodash
import _ from "lodash";
Vue.prototype._ = _;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
